div<template>
    <div class="">
        <div class="section-cat-home bg-tran ">
            <CategoryList />
        </div>
        <div v-if="GetDataAnnounce != null" class="section-notice-welcome text-white text-center d-flex justify-center bg-gold">
            <marquee behavior="scroll" direction="left">
                <span v-for="(item, index) of GetDataAnnounce">
                    {{ item.TEXTANNOUNCE_TEXT }}
                    <span style="margin-left: 2in;"></span>
                </span>
            </marquee>
           
        </div>
        <div class=" bg-tran section-carousel">
            <v-container>
                <v-row>
                    <v-col cols="12" class="">
                        <v-carousel class="vuetify-carousel" cycle height="150px" hide-delimiter-background
                            show-arrows-on-hover :show-arrows="false">
                            <v-carousel-item v-for="(n, index) in getBannerHome" :key="index" class="bg-tran">
                                <v-sheet dark class="bg-tran">
                                    <v-row class="fill-height" align="center">
                                        <v-col cols="12" lg="12">
                                            <div class="position-relative" @click="gotoPath(n.path)">
                                                <img aspect-ratio="1"
                                                    :class="n.name == 'aff' ? 'image-container' : 'image-container'" contain
                                                    :src="n.img" height="150px">
                                                    <div v-if="n.name == 'aff'" class="text-overlay">
                                                        <div class="text-center text-white font-weight-bold">{{
                                                            GetMemberDetail != null ? GetMemberDetail.REVCA : 0 }}</div>
                                                    </div>

                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="container">
            <v-row>
                <v-col cols="12">
                    <v-img aspect-ratio="1" contain :src="textGameHitImage" height="20px"></v-img>
                </v-col>
            </v-row>
        </div>
        <div class="">
            <div class="section-cat-list-home d-flex justify-space-between">
                <v-img v-for="(item, index) in getGameHitList" aspect-ratio="1" contain :src="item.image" height="120px"
                    @click="setGameHits(item, index)" class="image-cate-game-hits"
                    :class="item.active ? 'active' : ''"></v-img>
            </div>
        </div>
        <div class="container">
            <v-row class="">
                <v-col class="pa-0" cols="4"
                    v-for="(itemGameHome, indexGameHome) in GetTopGame(getGameDataDetailHomePage)">
                    <div class="d-flex align-center justify-center position-relative"
                        :ref="'game_id_' + itemGameHome.ID">
                        <div style="padding: 10px !important;" class="text-center w-100"
                            @click="goToGame(itemGameHome)">
                            <div style="height:120px;" class="d-flex align-center justify-center">
                                <img v-if="itemGameHome.CATEGORY != 'Live-Casino'" class="image-game-detail"
                                    v-lazy="itemGameHome.IMAGE != null && itemGameHome.IMAGE != '' ? itemGameHome.IMAGE : itemGameHome.CASINOIMG"
                                    @error="setNoImage($event, itemGameHome)" />
                                <img v-if="itemGameHome.CATEGORY == 'Live-Casino'" class="image-game-detail"
                                    v-lazy="getGameImageAsset(itemGameHome.PROVIDER)"
                                    @error="setNoImage($event, itemGameHome)" />
                            </div>
                            <div class="d-flex align-center justify-center">
                                <div class=" game-cate-detail text-white   w-100 text-center bottom-0 mt-1">{{
                                    itemGameHome.NAME }}</div>
                            </div>
                        </div>
                    </div>
                </v-col>

            </v-row>
        </div>
        <div v-if="promotionData.length > 0">
            <div class="container">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between">
                            <div class="d-flex align-center">

                                <h2 class="font-weight-bold text-white text-color-gold">Promotion</h2>
                            </div>
                            <div href="#"
                                class="font-weight-bold bg-gold d-flex justify-space-between align-center cursor-pointer"
                                @click="goToPromotion();">
                                เพิ่มเติม
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" class="bg-black">
                        <v-carousel class="vuetify-carousel" cycle height="110px" hide-delimiter-background
                            show-arrows-on-hover :show-arrows="false">
                            <v-carousel-item v-for="(n, index) in promotionData" :key="index">
                                <v-sheet dark>
                                    <v-row @click="showPrmotionDetail(n)" class="fill-height" align="center">
                                        <v-col cols="12" lg="12">
                                            <v-img aspect-ratio="1" contain :src="n.PROMOTION_IMAGE"
                                                height="110px"></v-img>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                </v-row>
            </div>
        </div>
        <!-- section-2  -->
        <div class="container mb-60" v-for="(item, index) in getGameDataCateHomePage">
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between mb-4">
                        <div class="d-flex align-center">
                            <img class="icon mr-2" src="@/assets/images/home-page/text_slot_image.png" alt="" />

                            <h2 class="font-weight-bold text-white text-color-gold">{{ item.CategoryName }}</h2>
                        </div>
                        <div href="#"
                            class="font-weight-bold bg-gold d-flex justify-space-between align-center cursor-pointer"
                            @click="gotoGameList(item);">
                            เพิ่มเติม
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" class="">
                    <v-row>
                        <v-col v-for="(itemGame, indexGame) in ConvertToArray(item.Data)" cols="3">
                            <img v-lazy="itemGame.image" width="100%" alt="" @error="setNoImage"
                                @click="gotoGameList(item, itemGame);">
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>


        <v-dialog v-model="dialog_promo" width="500">
            <v-card class="custom-card-main">
                <v-card-title class="text-h5 bg-gold">
                    {{ prmotionDetail != null ? prmotionDetail.PROMOTION_NAME : ''}}
                </v-card-title>

                <div class="pa-2" v-if="prmotionDetail != null">
                    <v-img :src="prmotionDetail.PROMOTION_IMAGE" class="wheel-image"></v-img>
                </div>
                <div>
                    <v-card-text class="pa-2">
                        {{ prmotionDetail != null ? prmotionDetail.PROMOTION_DES : '' }}
                    </v-card-text>
                </div>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="danger" text @click="dialog_promo = false">
                        ปิด
                    </v-btn>
                    <v-btn color="blue" text @click="confirmPromotion()">
                        รับโปรโมชั่น
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Navbar from "@/views/home/navbar";
import CardCart from "@/components/cartCard/CardCart";
import { mapGetters, mapActions } from 'vuex';
import CategoryList from "@/components/CategoryList.vue" 
export default {
    // name: 'Home',
    components: {
        Navbar,
        CardCart,
        CategoryList
    },
    computed: {
        ...mapGetters(['GetDataAnnounce', 'GetMemberDetail', 'getIsLogin','getProducts', 'getGameCategoryList', 'gameDataDetail', 'getGameDataDetailHomePage', 'getGameDataCateHomePage', 'getGameHitList','getBannerHome']),
    },
    data() {
        return {
            gameEx: require("@/assets/images/home-page/game_ex.png"),
            gameHitList: [
                { image:  require("@/assets/images/home-page/GameHitSlot.png")},
                { image:  require("@/assets/images/home-page/GameHitBarcarat.png")},
                { image:  require("@/assets/images/home-page/GameHitCard.png")},
                { image:  require("@/assets/images/home-page/GameHitFishing.png")}
            ],
            heroSlider: [
                {
                    img: require("@/assets/images/carousel/banner_1.png"),
                    name: "50% Off For Your First Shopping",
                },
            ],
            tab: null,
            items: ["Brands", "Shops"],
            textGameHitImage: require("@/assets/images/home-page/game_hit.png"),
            gameHitListCate: [],
            promotionList: [],
            dialog_promo: false,
            prmotionDetail: null,
            promotionData: [
            ],
            dataAnnounce: null,
        }; 
    }, 
    mounted() { 
        // this.GetGamePage();
        // this.initPromotionList()
        if (this.getIsLogin) this.MemberDetail()
    },
    methods: {
        ...mapActions(['MemberTextAnnounce', 'MemberDetail', "setModalLogin", "ConfirmReceiveCreditFree", "PromotionList", "addCart", "removeCart", "GetGamePage", "JoinGame", "setGameCateCurrent", "setGameCateListCurrent", "setGameHitCurrent", "setGameHitList"]),
        goToPromotion() {
            this.$router.push({ name: "Promotion" });
        },
        gotoPath(path) {
            if (path == '') return
            this.$router.push({ path: path });
        },
        async initPromotionList() {
            let res = await this.PromotionList()
            if (res !== false) {
                if (res.Status == 'OK') {
                    this.promotionList = res.Data
                }
            }
        },
        async confirmPromotion() {
            let res = await this.ConfirmReceiveCreditFree(this.prmotionDetail.PROMOTION_ID)
            if (res !== false) {
                if (res.Status == 'OK') {
                    createToastInterface().success(res.Msg)
                    this.dialog = false
                } else {
                    createToastInterface().error(res.Msg)
                }
            }
       },
        showPrmotionDetail(item) {
            this.prmotionDetail = item
            this.dialog_promo = true
        },
        async goToGame(item) {
            // console.log('MobileCategories.vue -> goToGame -> itemDataGame', JSON.stringify(item, null, 2), href)
            if (!this.getIsLogin) {
                this.setModalLogin(true)
                return
            }
            let PROVIDER,
                NAME,
                MOREDES,
                MOREDES_h,
                MOREDES_w,
                MOREDES_GAMETYPEID,
                MOREDES_TYPEDES,
                MOREDES_TECHNOLOGY,
                MOREDES_PLATFORM,
                href,
                game_url
                if( item.MOREDES !== undefined && item.MOREDES ) {
                    PROVIDER    =   (item.PROVIDER !== undefined ? item.PROVIDER.toLowerCase() : ``)
                    NAME        =   (item.NAME !== undefined ? item.NAME.replace(`'`,`\\'`) : ``)

                    MOREDES     =   JSON.parse(item.MOREDES)
                    MOREDES_h   =   (MOREDES.h !== undefined ? `&h=${MOREDES.h}` : ``);
                    MOREDES_w   =   (MOREDES.w !== undefined ? `&w=${MOREDES.w}` : ``);

                    MOREDES_GAMETYPEID =   (MOREDES.GAMETYPEID !== undefined ? `&GAMETYPEID=${MOREDES.GAMETYPEID}` : ``);
                    MOREDES_TYPEDES    =   (MOREDES.TYPEDES    !== undefined ? `&TYPEDES=${MOREDES.TYPEDES}`       : ``);
                    MOREDES_TECHNOLOGY =   (MOREDES.TECHNOLOGY !== undefined ? `&TECHNOLOGY=${MOREDES.TECHNOLOGY}` : ``);
                    MOREDES_PLATFORM   =   (MOREDES.PLATFORM   !== undefined ? `&PLATFORM=${MOREDES.PLATFORM}`     : ``);

                    // if( nameGroup.toLowerCase() === "agslot" )
                    // {
                    //     // if( is_mobile() === false )
                    //     // {
                    //     //     game_url =  `${baseURL}/games/client/${item.CATEGORY}/${PROVIDER}`
                    //     //     href     =  `javascript:windowPopup('${nameGroup}-${NAME}','${game_url}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}');`
                    //     // }
                    //     // else
                    //     // {
                    //         href     =  `${baseURL}/games/client/${item.CATEGORY}/${PROVIDER}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}`;
                    //         target   =  "target='_blank'";
                    //     // }
                    // }
                    // else
                    // {
                        href    =   `/${item.CATEGORY}/${PROVIDER}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}`
                    // }
                    let resJoinGame = await this.JoinGame(href);
                    if (typeof resJoinGame == 'object' && resJoinGame.hasOwnProperty('Status')) {
                        if (resJoinGame.Status == 'SUCCESS') {
                            this.$router.push({ name: "Play Games", params: { dataGameJoin: resJoinGame.Data } });
                        }
                    }
                    // console.log('MobileCategories.vue -> goToGame -> resJoinGame', resJoinGame)
                } else {
                    if (item.CATEGORY == 'Live-Casino') {
                        let arrGame = ['hotgraph' ,'agcasino' ,'sexygaming']
                        let href = ''
                        if (arrGame.indexOf(item.ID.toLowerCase()) != -1) {
                            href = `/${item.CATEGORY}/${item.ID}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}`
                        } else {
                            href = `/${item.CATEGORY}/${item.ID.toLowerCase()}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}`
                        }
                        let resJoinGame = await this.JoinGame(href);
                        if (typeof resJoinGame == 'object' && resJoinGame.hasOwnProperty('Status')) {
                            if (resJoinGame.Status == 'SUCCESS') {
                                this.$router.push({ name: "Play Games", params: { dataGameJoin: resJoinGame.Data } });
                            }
                        }
                    }
                }
           
        },
        ConvertToArray(dataListGame) {
            let dataListGameNew = []
            if (dataListGame != null && typeof dataListGame == 'object') {
                if (Object.keys(dataListGame).length > 0) {
                    for(let index in dataListGame) {
                        let imgPath = ''
                        try {
                            imgPath = require(`@/assets/images/_games/${index}.png`)    
                        } catch (error) {
                            
                        }
                        let gameObj = {
                            GameName: index,
                            image: imgPath
                        }
                        dataListGameNew.push(gameObj)
                    }
                }
            }
            // console.log('Home.vue -> ConvertToArray -> dataListGameNew', dataListGameNew)
            return dataListGameNew
        },
        setNoImage(e, item) {
            // console.log('Home.vue -> setNoImage -> e', '5555')
            e.target.src = require("@/assets/images/Image_not_available.png")
            // get ref
            // let target = this.$refs[`game_id_${item.ID}`][0]
            // let targetDetail = this.$refs[`game_id__detail_${item.ID}`][0]
            // targetDetail.innerHTML = `${item.NAME}`
            // targetDetail.classList.remove('hide')
            // console.log('Home.vue -> setNoImage -> target', target)
            // target.innerHTML = `awdawd`
        },
        GetTopGame(gameList = []) {
            let gameListNew = []
            if (gameList != null && typeof gameList == 'object') {
                
                if (Object.keys(gameList).length > 0) {
                    for(let index in gameList) {
                        if (gameListNew.length != 12) {
                            if (gameList[index].length > 0) {
                                gameListNew.push(gameList[index][0])
                            }
                        } else {
                            break
                        }
                    }
                }
            }
            // console.log('Home.vue -> GetTopGame -> gameListNew', gameListNew)
            return gameListNew
        },
        setGameHits(itemDataCate, index) {
            this.setGameHitList({GAME_CATEGORY_ID: itemDataCate.GAME_CATEGORY_ID})
            // this.setGameHitCurrent();
            // console.log('Home.vue -> setGameHits -> itemDataCate', JSON.stringify(itemDataCate, null, 2))
            this.GetGamePage({GAME_CATEGORY_ID: itemDataCate.GAME_CATEGORY_ID, GAME_HITS: true})
            // this.$router.push({ name: "Mobile Categories" , params: { GAME_CATEGORY_ID: itemDataCate.GAME_CATEGORY_ID } });
        },
        getTopCateHits(dataGame) {
            // console.clear()
            // console.log('Home.vue -> getTopCateHits -> dataGame', dataGame)
            let gameNewList = []
            if (dataGame.length > 0) {
                // slice 4 item
                gameNewList = dataGame.slice(0, 4)
                for (let index in gameNewList) {
                    if (index == 0) gameNewList[index]['active'] = true 
                    else gameNewList[index]['active'] = false
                    gameNewList[index]['image'] = this.gameHitList[index].image
                }
            }
            return gameNewList
        },
        gotoGameList(itemData, itemDataGame = null) {
            this.setGameCateCurrent(itemData.GAME_CATEGORY_ID)
            this.GetGamePage({GAME_CATEGORY_ID: itemData.GAME_CATEGORY_ID})
            if (itemDataGame != null && typeof itemDataGame == 'object') {
                this.setGameCateListCurrent(itemDataGame.GameName)
            }
            if (this.$route.name == "Mobile Categories") {
               
            } else {
                // console.log('Home.vue -> gotoGameList -> itemData, itemDataGame', itemData, itemDataGame)
                this.$router.push({ name: "Mobile Categories with layout" , params: { GAME_CATEGORY_ID: itemData.GAME_CATEGORY_ID } });
            }
        },
        groupingCat(catList) {
            let config_cut_item = 4
            let newCatList = []
            if (catList.length > 0) {
                for (let index in catList) {
                    if (index % config_cut_item == 0) {
                        newCatList.push(catList.slice(index, index + config_cut_item))
                    }
                }
            }
            // console.log('Home.vue -> groupingCat -> newCatList', newCatList)
            return newCatList
        },
        convertImage(image) {
            let mdIconName = ""
            // console.log('Home.vue -> convertImage -> image', image)
            if (image == 'fas fa-spade') {
                mdIconName = "mdi-cards-spade"
            } else if (image == 'fas fa-club') {
                mdIconName = "mdi-cards-club"
            } else if (image == 'fas fa-dice') {
                mdIconName = "mdi-dice-6"
            } else if (image == 'fas fa-bomb') {
                mdIconName = "mdi-bomb"
            } else if (image == 'fas fa-chess') {
                mdIconName = "mdi-chess-queen"
            } else if (image == 'fas fa-rocket') {
                mdIconName = "mdi-rocket"
            } else if (image == 'fas fa-diamond') {
                mdIconName = "mdi-diamond"
            } else if (image == 'fas fa-user-robot') {
                mdIconName = "mdi-robot"
            }  else if (image == 'fas fa-raygun') {
                mdIconName = "mdi-ray-gun"
            } else if (image == 'fas fa-dice-d10') {
                mdIconName = "mdi-dice-d10"
            } else if (image == 'fas fa-dice-d6') {
                mdIconName = "mdi-dice-d6"
            } else if (image == 'fas fa-snake') {
                mdIconName = "mdi-snake"
            } else if (image == 'fas fa-meteor') {
                mdIconName = "mdi-meteor"
            } else {
                mdIconName = "mdi-poker-chip"
            }
            return mdIconName
        },
        getGameImageAsset(index) {
            try {
                return require(`@/assets/images/_games/${index}.png`)
            } catch (error) {
                return ""
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.top-categories-img {
    width: 385px;
    min-width: 100%;
    max-width: 100%;

}
.v-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-cat-game {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2d2d2d;
    border-radius: 10px;
}
@media screen and (min-width: 700px) {
    .card-cat-game {
        width: 100px;
        height: 100px;
    } 
}
.section-notice-welcome {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
.game-cate-detail {
    background: #282828;
    border-radius: 10px;
    padding: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100px;
    font-size: 12px;
}
.image-game-detail {
    width: 80%;
    height: auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.image-cate-game-hits {
    // grey scale
    filter: grayscale(100%);
}
.image-cate-game-hits.active {
    // grey scale
    filter: grayscale(0%);
}
.section-cat-home {
    background: transparent !important;
}

</style>
